export enum NotificationFor {
  SuperAdmin = 1,
}

export const NotificationForArray = [1];
